import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_export_data_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { type: ('report' | 'data'), module_id: string, component_id: string, inputs?: any, description?: string, wait_for_result?: boolean, data?: { header_mappings?: any }, report?: { file_type?: ('pdf' | 'csv' | 'html' | 'xlsx') } }): Promise<void> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.type)) {
      $missingRequiredInParams.push('\'type\'');
    }
    if (isNil($inParams.module_id)) {
      $missingRequiredInParams.push('\'module_id\'');
    }
    if (isNil($inParams.component_id)) {
      $missingRequiredInParams.push('\'component_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

